export default __webpack_public_path__ + "static/Building_A_Brand-4f9cf25da108596e30bb984cdbacab3d.png";